const PatientsWithForecast = ({ patients, forecastData }) => 
	patients?.map((patient) => {
    const forecastDetails = forecastData?.data?.find((forecast) => forecast.patient_id === patient.id);
      return {
        ...patient,
        predict_percent: (forecastDetails && forecastDetails.predict_percent) || "Sin información",
        predict_category: (forecastDetails && forecastDetails.predict_category) || "Sin información",
      };
		})


export default PatientsWithForecast;
